import _ from "lodash";
import { http } from "../Guard";
import {
  createPaginatedGet,
  createGetById,
  createAdd,
  createUpdate,
  createDelete,
  createRestore,
  createArchivedGet,
  createExportFn,
  createAssignFn,
} from "./data.helpers";
import {
  ReportComponentData,
  ReportComponentInput,
  ReportBandData,
  ReportBandInput,
  ReportEvaluation,
  MetricDefinitionData,
  MetricDefinitionInput,
  MetricBandData,
  MetricBandInput,
  OrganizationalMetricEntryData,
  OrganizationalMetricEntryInput,
} from "./data.default";
import {
  TargetingPreviewInput,
  TargetingPreviewResult,
  Pagination,
  Question,
} from "./data.default";
import {
  Roadmap,
  RoadmapsData,
  RoadmapInput,
  RoadmapStage,
  RoadmapStagesData,
  RoadmapStageInput,
  RoadmapRequirement,
  RoadmapRequirementsData,
  RoadmapRequirementInput,
  RoadmapCompany,
  RoadmapCompaniesData,
  RoadmapCompanyInput,
} from "./data.default";
import {
  PaginationInput,
  CompanyData,
  CompanyPolicyData,
  CompanyIndustryData,
  PlatformUserData,
  CompanyRoleData,
  CompanyPolicyInput,
  CompanyInput,
  AffiliateDocument,
  PermissionAction,
  PermissionMatrix,
  CompanyContact,
  CompanyContactData,
  CompanyContactInput,
  CompanyRoleInput,
  CompanyIndustryInput,
  DepartmentData,
  DepartmentInput,
  FiscalPeriod,
  FiscalPeriodData,
  FiscalPeriodInput,
  ManagerUserData,
  EmployeeUserData,
  DataLogData,
  RewardsData,
  CompanyRewardsData,
  DepartmentsRewardsData,
  UsersRewardsData,
  RewardRedemptionData,
  RewardRedemption,
  RewardRedemptionRejectInput,
  CompanyRewardInput,
  DepartmentRewardInput,
  UserRewardInput,
  CalendarEventsData,
  CalendarEventInput,
  CalendarEventTypesData,
  CalendarEvent,
  RewardInput,
  Reward,
  BadgesData,
  CompanyBadgesData,
  DepartmentsBadgesData,
  UsersBadgesData,
  CompanyBadgeInput,
  DepartmentBadgeInput,
  UserBadgeInput,
  UserHistoryData,
  Department,
  Company,
  ActionLogData,
  CategoriesData,
  VariablesData,
  CalendarInvitationsData,
  CalendarCompanyInvitationInput,
  CalendarDepartmentInvitationInput,
  CalendarUserInvitationInput,
  CalendarInvitationsInput,
  EventsTypesData,
  EventsTypesInput,
  CategoriesInput,
  LanguageInput,
  LoginLogsData,
  PointsRulesData,
  PointsRuleInput,
  CompanyPolicyAcknowledgmentsData,
  IncidentFollowUpsData,
  IncidentFollowUpInput,
  ProgramCategoriesData,
  ProgramCategoryInput,
  VariablesInput,
  TemplatesData,
  TemplateVersionsData,
  TemplatesInput,
  TemplatePreviewInput,
  TemplatePreview,
  MyNotificationsData,
  MyNotificationRead,
  NotificationInput,
  NotificationsData,
  NotificationRecipientsData,
  TemplateEventsData,
  TemplateEventInput,
  IncidentsData,
  IncidentInput,
  IncidentCommentsData,
  IncidentCommentsInput,
  IncidentCommentInput,
  AddIncidentCommentInput,
  Incident,
  IncidentReporter,
  IncidentType,
  IncidentTypesData,
  IncidentTypeInput,
  AssetType,
  AssetTypesData,
  AssetTypeInput,
  AssetSubtype,
  AssetSubtypesData,
  AssetSubtypeInput,
  CompanyAsset,
  CompanyAssetsData,
  CompanyAssetInput,
  IncidentTypeNotifiersData,
  IncidentTypeNotifierInput,
  PlatformUser,
  ManagerUser,
  EmployeeUser,
  LabelsData,
  LabelInput,
  LanguagesData,
  CountriesData,
  CompanyRoleLableInput,
  CompanyRole,
  CollaboratorsData,
  Collaborator,
  CollaboratorInput,
  TenantsData,
  ConsultantsData,
  Consultant,
  ConsultantInput,
  AdminInput,
  AdminUpdateInput,
  UserAccount,
  MyCalendarEventsData,
  PlatformPermissionData,
  PlatformPermissionInput,
  CompanyPermissionData,
  CompanyPermissionInput,
  PermissionData,
  PlatformRolesData,
  InvoicesData,
  InvoiceInput,
  Invoice,
  InvoiceItemsData,
  InvoiceItemInput,
  BundlesData,
  BundleInput,
  QuestionnairesData,
  QuestionnaireInput,
  Questionnaire,
  QuestionnaireSectionsData,
  QuestionnaireSectionInput,
  QuestionnaireSection,
  QuestionnaireQuestionsData,
  QuestionnaireQuestionInput,
  QuestionnaireQuestion,
  QuestionnaireQuestionChoicesData,
  QuestionnaireQuestionChoiceInput,
  QuestionnaireQuestionChoice,
  QuestionnaireQuestionTranslationsData,
  QuestionnaireQuestionTranslationInput,
  QuestionnaireQuestionTranslation,
  QuestionnaireQuestionChoiceTranslationsData,
  QuestionnaireQuestionChoiceTranslationInput,
  QuestionnaireQuestionChoiceTranslation,
  MAX_PAGE_SIZE,
  BundlesAssignmentsData,
  BundleAssignmentInput,
  BundleAssignmentUpdateInput,
  TestGroup,
  TestGroupData,
  TestGroupInput,
  CompanyCollaboratorsData,
  CompanyCollaboratorInput,
  WellbeingReportsData,
  WellbeingReportInput,
  ReportTargetOption,
  ReviewersData,
  ReportFilesData,
  CounsellingRequestsData,
  CounsellingRequestInput,
  CounsellingRequestUpdateInput,
  CounsellingProposeInput,
  Training,
  TrainingsData,
  TrainingInput,
  TrainingUpdateInput,
  TrainingAttendanceItem,
  TestGroupUserData,
  BundleQuestionnairesData,
  BundleQuestionnaireInput,
  LoyaltyHistoryData,
  CompanyPolicyInputFile,
  AnswerData,
  CompanyRolesLabelsData,
  UserLabelsData,
  UserLableInput,
  KpisData,
  KpiInput,
  KpisQuestionsData,
  KpiQuestionInput,
  KpiMatrixInput,
  RangeInput,
  KpiMatricesData,
  RangesData,
  QuestionAnswerData,
  QuestionnaireAnswerKPIResultsData,
  AssessmentReport,
  AssessmentReportData,
  AssessmentReportInput,
  ReportKpiDefinitionData,
  ReportKpiDefinitionInput,
  UserProfileInput,
  WellbeingMaterialData,
  WellbeingMaterialFile,
  WellbeingMaterialInput,
  WellbeingMaterialCategoryData,
  WellbeingMaterialCategoryInput,
  WellbeingMaterialKpiData,
  WellbeingMaterialKpiInput,
  WellbeingMaterialAssignmentData,
  WellbeingMaterialEngagementData,
  WellbeingMaterialRecommendationData,
  WellbeingMaterialCoverage,
  DashboardFilters,
  DashboardUserActivity,
  DashboardQuestionnaireStatus,
  DashboardRisks,
  DashboardRiskDomains,
  DashboardRiskTrend,
  DashboardRiskCompaniesPage,
  DashboardIncidents,
  DashboardIncidentCompaniesPage,
  DashboardRewardsLoyalty,
  DashboardAffiliates,
  DashboardAffiliateWorkloadPage,
} from "./data.default";
import { QueryOperation } from "../code/search-query/search-query";

// User Login History

export const getUserLoginHistory = createPaginatedGet<UserHistoryData>("api/Data/UserLoginHistory");

// Platform Users

export const getPlatformUsers = createPaginatedGet<PlatformUserData>("/api/Data/PlatformUsers");
export const getUser = createGetById<UserAccount>("/api/Data/Accounts/Users");
export const getPlatformUsersExport = createExportFn("/api/Data/PlatformUsers/Export", "users-export.xlsx");
export const updateUserProfile = createUpdate<UserProfileInput>("/api/Data/UserProfiles");
export const deleteUser = createDelete("/api/Data/PlatformUsers");
export const restoreUser = createRestore("/api/Data/PlatformUsers");
export const getArchivedUsers = createArchivedGet<PlatformUserData>("/api/Data/PlatformUsers");

// Platform Admins

export const getPlatformAdmins = createPaginatedGet<PlatformUserData>("/api/Data/PlatformAdmins");
export const addPlatformAdmin = createAdd<AdminInput>("/api/Auth/RegisterAdmin");
export const updatePlatformAdmin = (uid: string, input: AdminUpdateInput) =>
  http.put(`/api/Auth/UpdateAdmin/${uid}`, input).then(({ data }) => data);
export const deletePlatformAdmin = (uid: string) =>
  http.delete(`/api/Auth/DeleteAdmin/${uid}`).then(({ data }) => data);

// Audit fix 4 (2026-11-04) — assign/revoke the AppCompanyAdmin platform role.
// Both are idempotent on the server.
export const promoteToCompanyAdmin = (uid: string) =>
  http.post(`/api/Auth/PromoteToCompanyAdmin/${uid}`, {}).then(({ data }) => data);
export const demoteFromCompanyAdmin = (uid: string) =>
  http.post(`/api/Auth/DemoteFromCompanyAdmin/${uid}`, {}).then(({ data }) => data);

// Companies

export const getCompanies = createPaginatedGet<CompanyData>("api/Data/Companies");
export const getCompany = createGetById<Company>("/api/Data/Accounts/Companies");
export const addCompany = createAdd<CompanyInput, Company>("/api/Data/Companies");
// Industry (domainUid) and parentCompanyUid are set-once at registration — the API rejects
// changes, so they are omitted from the update payload (locked for platform integrity).
export const updateCompany = createUpdate<
  Omit<CompanyInput, "domainUid" | "parentCompanyUid">,
  Company
>("/api/Data/Companies");
export const deleteCompany = createDelete("/api/Data/Companies");
// Archive / restore (admin brief 2026-11-03).
export const restoreCompany = createRestore("/api/Data/Companies");
export const getArchivedCompanies = createArchivedGet<CompanyData>("/api/Data/Companies");
export const getCompaniesExport = createExportFn("api/Data/Companies/Export", "companies-export.xlsx");

// Admin brief 2026-11-04 — full contacts list per company.
export const getCompanyContacts = createPaginatedGet<CompanyContactData>("/api/Data/CompanyContacts");

// Admin brief 2026-11-04 — Affiliate documents (admin-only CRUD).
export function getAffiliateDocuments(userUid: string): Promise<AffiliateDocument[]> {
  return http
    .get<AffiliateDocument[]>(`/api/Data/AffiliateDocuments/User/${userUid}`)
    .then(({ data }) => data);
}

export function uploadAffiliateDocument(
  userUid: string,
  file: File,
  documentType?: string,
  notes?: string,
): Promise<AffiliateDocument> {
  const formData = new FormData();
  formData.append("file", file);
  if (documentType) formData.append("documentType", documentType);
  if (notes) formData.append("notes", notes);
  return http
    .post<AffiliateDocument>(`/api/Data/AffiliateDocuments/${userUid}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then(({ data }) => data);
}

export function downloadAffiliateDocument(
  uid: string,
  fileName: string,
): Promise<void> {
  return http
    .get(`/api/Data/AffiliateDocuments/${uid}/File`, { responseType: "blob" })
    .then(({ data }) => {
      const link = document.createElement("a");
      const urlBlob = window.URL.createObjectURL(new Blob([data]));
      try {
        link.href = urlBlob;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      } finally {
        link.remove();
        window.URL.revokeObjectURL(urlBlob);
      }
    });
}

export const deleteAffiliateDocument = createDelete("/api/Data/AffiliateDocuments");

// Admin brief 2026-11-04 — Affiliate verification workflow (admin-only).
export function verifyAffiliate(uid: string) {
  return http.post(`/api/Data/AffiliateVerification/${uid}/Verify`, {}).then(({ data }) => data);
}

export function rejectAffiliate(uid: string, reason?: string) {
  return http
    .post(`/api/Data/AffiliateVerification/${uid}/Reject`, { reason })
    .then(({ data }) => data);
}

export function returnAffiliateToPending(uid: string) {
  return http.post(`/api/Data/AffiliateVerification/${uid}/ToPending`, {}).then(({ data }) => data);
}
export const addCompanyContact = createAdd<CompanyContactInput, CompanyContact>("/api/Data/CompanyContacts");
export const updateCompanyContact = createUpdate<CompanyContactInput>("/api/Data/CompanyContacts");
export const deleteCompanyContact = createDelete("/api/Data/CompanyContacts");

// A company plus all of its recursive sub-companies — i.e. the companies that would inherit a record scoped here.
export function getCompanyDescendants(uid: string): Promise<Company[]> {
  return http
    .get(`/api/Data/Companies/${uid}/Descendants`)
    .then(({ data }) => data);
}

export function uploadCompanyLogo(file: File, uid: string): Promise<any> {
  const formData = new FormData();
  formData.append("logoFile", file);
  return http
    .post(`/api/auth/CompanyProfile/${uid}/logo`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(({ data }) => data);
}

export function getCompanyLogo(uid: string): Promise<string> {
  return http
    .get(`/api/auth/CompanyProfile/${uid}/logo`, {
      responseType: "blob",
    })
    .then((response) => {
      // 204 No Content (or an empty body) means the company has no logo uploaded — reject so the
      // caller falls back to its default logo, without a noisy 404 in the console.
      if (
        response.status === 204 ||
        !response.data ||
        (response.data as Blob).size === 0
      ) {
        return Promise.reject(new Error("no-logo"));
      }
      return URL.createObjectURL(response.data);
    });
}

// Departments

export const getCompanyDepartments = createPaginatedGet<DepartmentData>("/api/Data/CompanyDepartments");
export const getDepartment = createGetById<Department>("/api/Data/Accounts/Departments");
export const addCompanyDepartment = createAdd<DepartmentInput>("api/Data/CompanyDepartments");
export const updateCompanyDepartment = createUpdate<DepartmentInput>("/api/Data/CompanyDepartments");
export const deleteCompanyDepartment = createDelete("/api/Data/CompanyDepartments");
export const getCompanyDepartmentsExport = createExportFn("/api/Data/CompanyDepartments/Export", "departments-export.xlsx");

// Fiscal Periods

export const getCompanyFiscalPeriods = createPaginatedGet<FiscalPeriodData>("/api/Data/CompanyFiscalPeriods");
export const getCompanyFiscalPeriod = createGetById<FiscalPeriod>("/api/Data/CompanyFiscalPeriods");
export const addCompanyFiscalPeriod = createAdd<FiscalPeriodInput>("/api/Data/CompanyFiscalPeriods");
export const updateCompanyFiscalPeriod = createUpdate<FiscalPeriodInput>("/api/Data/CompanyFiscalPeriods");
export const deleteCompanyFiscalPeriod = createDelete("/api/Data/CompanyFiscalPeriods");
export const getCompanyFiscalPeriodsExport = createExportFn("/api/Data/CompanyFiscalPeriods/Export", "fiscal-periods-export.xlsx");

// Employees

export const getCompanyEmployees = createPaginatedGet<EmployeeUserData>("/api/Data/CompanyEmployees");
export const getCompanyEmployeesExport = createExportFn("/api/Data/CompanyEmployees/Export", "employees-export.xlsx");
export const getEmployee = createGetById<EmployeeUser>("/api/Data/CompanyEmployees");
export const updateEmployee = createUpdate<UserProfileInput>("/api/Data/UserProfiles");
export const deleteEmployee = createDelete("/api/Data/CompanyEmployees");
export const restoreEmployee = createRestore("/api/Data/CompanyEmployees");
export const getArchivedEmployees = createArchivedGet<EmployeeUserData>("/api/Data/CompanyEmployees");

// Managers

export const getCompanyManagers = createPaginatedGet<ManagerUserData>("/api/Data/CompanyManagers");
export const getCompanyManagersExport = createExportFn("/api/Data/CompanyManagers/Export", "managers-export.xlsx");
export const getManager = createGetById<ManagerUser>("/api/Data/CompanyManagers");
export const updateManager = createUpdate<UserProfileInput>("/api/Data/UserProfiles");
export const deleteManager = createDelete("/api/Data/CompanyManagers");
export const restoreManager = createRestore("/api/Data/CompanyManagers");
export const getArchivedManagers = createArchivedGet<ManagerUserData>("/api/Data/CompanyManagers");

// User Roles

export const getCompanyUserRoles = createPaginatedGet<CompanyRoleData>("/api/Data/CompanyRoles");
export const addCompanyUserRole = createAdd<CompanyRoleInput, CompanyRole>("api/Data/CompanyRoles");
export const updateCompanyUserRole = createUpdate<CompanyRoleInput, CompanyRole>("/api/Data/CompanyRoles");
export const deleteCompanyUserRole = createDelete("/api/Data/CompanyRoles");
export const getCompanyUserRolesExport = createExportFn("/api/Data/CompanyRoles/Export", "user-roles-export.xlsx");

// Industries

export const getCompanyIndustries = createPaginatedGet<CompanyIndustryData>("api/Data/CompanyDomains");
export const addCompanyIndustry = createAdd<CompanyIndustryInput>("/api/Data/CompanyDomains");
export const updateCompanyIndustry = createUpdate<CompanyIndustryInput>("/api/Data/CompanyDomains");
export const deleteCompanyIndustry = createDelete("/api/Data/CompanyDomains");
export const getCompanyIndustriesExport = createExportFn("/api/Data/CompanyDomains/Export", "domains-export.xlsx");

// Labels
export const getLabels = createPaginatedGet<LabelsData>("api/Data/Labels");
export const addLabel = createAdd<LabelInput>("/api/Data/Labels");
export const updateLabel = createUpdate<LabelInput>("/api/Data/Labels");
export const deleteLabel = createDelete("/api/Data/Labels");
export const getLabelsExport = createExportFn("/api/Data/Labels/Export", "labels-export.xlsx");

// Company Roles Labels

export const getCompanyRoleLabels = createPaginatedGet<CompanyRolesLabelsData>("api/Data/LabelsCompanyRoles");

export function addCompanyRoleLabel(input: CompanyRoleLableInput) {
  return http
    .post(`/api/Data/LabelsCompanyRoles/${input.roleUid}/Labels`, input)
    .then(({ data }) => data);
}

export function deleteCompanyRoleLabel(roleUid: string, labelUid: string) {
  return http
    .delete(`/api/Data/LabelsCompanyRoles/${roleUid}/Labels/${labelUid}`)
    .then(({ data }) => data);
}

//User Labels

export const getUserLabels = createPaginatedGet<UserLabelsData>("api/Data/LabelsUsers");

export function addUserLabel(input: UserLableInput) {
  return http
    .post(`/api/Data/LabelsUsers/${input.userUid}/Labels`, input)
    .then(({ data }) => data);
}

export function deleteUserLabel(userUid: string, labelUid: string) {
  return http
    .delete(`/api/Data/LabelsUsers/${userUid}/Labels/${labelUid}`)
    .then(({ data }) => data);
}

// Policies

export const getCompanyPolicies = createPaginatedGet<CompanyPolicyData>("api/Data/CompanyPolicies");

export function addCompanyPolicy(input: CompanyPolicyInput) {
  const formData = new FormData();
  Object.entries(input).forEach(([key, value]) => {
    // Skip nullish so an omitted companyUid is sent as nothing (→ platform-wide), not the string "undefined".
    if (value != null) formData.append(key, value as any);
  });
  return http
    .post("/api/Data/CompanyPolicies", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(({ data }) => data);
}

export const updateCompanyPolicy = createUpdate<CompanyPolicyInput>("/api/Data/CompanyPolicies");

export function updateCompanyPolicyFile(input: CompanyPolicyInputFile) {
  return http
    .put(`/api/Data/CompanyPolicies/${input.uid}/pdf`, _.omit(input, ["uid"]), {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(({ data }) => data);
}

export const deleteCompanyPolicy = createDelete("/api/Data/CompanyPolicies");

export function previewCompanyPolicy(uid: string) {
  return http
    .get(`/api/Data/CompanyPolicies/${uid}/Pdf`, {
      responseType: "blob",
    })
    .then(({ data }) => {
      const pdfUrl = URL.createObjectURL(data);

      window.open(pdfUrl, "_blank");
    });
}

export const getCompanyPoliciesExport = createExportFn("/api/Data/CompanyPolicies/Export", "policies-export.xlsx");

// Data Logs

export const getDataLogs = createPaginatedGet<DataLogData>("/api/Data/AppAudits");
export const getDataLogsExport = createExportFn("/api/Data/AppAudits/Export", "data-logs-export.xlsx");

// Action Logs

export const getActionLogs = createPaginatedGet<ActionLogData>("/api/Data/ActionLogs");
export const getActionLogsExport = createExportFn("/api/Data/ActionLogs/Export", "action-logs-export.xlsx");

// Rewards

export const getRewards = createPaginatedGet<RewardsData>("api/Data/Rewards");

export const addReward = createAdd<RewardInput>("api/Data/Rewards");

export const updateReward = createUpdate<RewardInput>("api/Data/Rewards");

export const deleteReward = createDelete("api/Data/Rewards");

export const getRewardsExport = createExportFn("/api/Data/Rewards/Export", "rewards-export.xlsx");

export const getCompanyRewards = createPaginatedGet<CompanyRewardsData>("api/Data/RewardsAssignment/Companies");

// Reward assigns — the shared assignment-POST factory; the body carries the dates (+ rowVersion).
const assignRewardToCompany = createAssignFn("/api/Data/RewardsAssignment", "Company");
const assignRewardToDepartment = createAssignFn("/api/Data/RewardsAssignment", "Department");
const assignRewardToUser = createAssignFn("/api/Data/RewardsAssignment", "User");

export function addCompanyReward(input: CompanyRewardInput) {
  return assignRewardToCompany(input.rewardUid!, input.companyUid!, {
    body: _.omit(input, ["rewardUid", "companyUid"]),
  });
}

export const getDepartmentsRewards = createPaginatedGet<DepartmentsRewardsData>("api/Data/RewardsAssignment/Departments");
export function addDepartmentReward(input: DepartmentRewardInput) {
  return assignRewardToDepartment(input.rewardUid!, input.departmentUid!, {
    body: _.omit(input, ["rewardUid", "departmentUid"]),
  });
}

export const getUsersReward = createPaginatedGet<UsersRewardsData>("api/Data/RewardsAssignment/Users");
export function addUserReward(input: UserRewardInput) {
  return assignRewardToUser(input.rewardUid!, input.userUid!, {
    body: _.omit(input, ["rewardUid", "userUid"]),
  });
}

// Reward-assignment deletes (backend supports these; the UI previously left them unwired).
export const deleteCompanyRewardAssignment = createDelete("/api/Data/RewardsAssignment/Companies");
export const deleteDepartmentRewardAssignment = createDelete("/api/Data/RewardsAssignment/Departments");
export const deleteUserRewardAssignment = createDelete("/api/Data/RewardsAssignment/Users");

// Reward-assignment exports (per target; mirror the badge-assignment exports).
export const getCompaniesRewardsExport = createExportFn(
  "/api/Data/RewardsAssignment/Companies/Export",
  "companies-rewards-export.xlsx",
);
export const getDepartmentsRewardsExport = createExportFn(
  "/api/Data/RewardsAssignment/Departments/Export",
  "departments-rewards-export.xlsx",
);
export const getUsersRewardsExport = createExportFn(
  "/api/Data/RewardsAssignment/Users/Export",
  "users-rewards-export.xlsx",
);

// Reward redemptions (approval workflow)

export const getRewardRedemptions = createPaginatedGet<RewardRedemptionData>("api/Data/RewardRedemptions");
export const getRewardRedemption = createGetById<RewardRedemption>("/api/Data/RewardRedemptions");
export const getRewardRedemptionsExport = createExportFn(
  "/api/Data/RewardRedemptions/Export",
  "reward-redemptions-export.xlsx",
);

export function redeemReward(rewardUid: string) {
  return http
    .post(`/api/Data/RewardRedemptions/${rewardUid}/Redeem`, {})
    .then(({ data }) => data);
}

export function approveRedemption(uid: string) {
  return http
    .put(`/api/Data/RewardRedemptions/${uid}/Approve`, {})
    .then(({ data }) => data);
}

export function fulfillRedemption(uid: string) {
  return http
    .put(`/api/Data/RewardRedemptions/${uid}/Fulfill`, {})
    .then(({ data }) => data);
}

export function rejectRedemption(uid: string, input: RewardRedemptionRejectInput) {
  return http
    .put(`/api/Data/RewardRedemptions/${uid}/Reject`, input)
    .then(({ data }) => data);
}

export function cancelRedemption(uid: string) {
  return http
    .post(`/api/Data/RewardRedemptions/${uid}/Cancel`, {})
    .then(({ data }) => data);
}

// Calendar

export const getCalendarEvents = createPaginatedGet<CalendarEventsData>("/api/Data/CalendarEvents");
export const getCalendarEventsExport = createExportFn("/api/Data/CalendarEvents/Export", "calendar-events-export.xlsx");

// Single event by uid (no dedicated get-by-id endpoint) — used to deep-link from a counselling request.
export const getCalendarEvent = (uid: string) =>
  getCalendarEvents({
    searchQuery: { conditions: [{ field: "uid", operation: QueryOperation.Equal, values: [uid] }] },
    pageNumber: 0,
    pageSize: 1,
  }).then(({ data }) => data[0]);

export const addCalendarEvent = createAdd<CalendarEventInput, CalendarEvent>("/api/Data/CalendarEvents");
export const updateCalendarEvent = createUpdate<CalendarEventInput, CalendarEvent>("/api/Data/CalendarEvents");
export const deleteCalendarEvent = createDelete("/api/Data/CalendarEvents");

// Events Types
export const getEventsTypes = createPaginatedGet<EventsTypesData>("api/Data/CalendarEventsTypes");
export const getEventsTypesExport = createExportFn("/api/Data/CalendarEventsTypes/Export", "events-types-export.xlsx");
export const addEventType = createAdd<EventsTypesInput>("/api/Data/CalendarEventsTypes");
export const updateEventsTypes = createUpdate<EventsTypesInput>("/api/Data/CalendarEventsTypes");
export const deleteEventsTypes = createDelete("/api/Data/CalendarEventsTypes");

// My Calendar
export const getMyCalendarEvents = createPaginatedGet<MyCalendarEventsData>("/api/Data/CalendarEventsInvitations/MyInvitations");

// Calendar Invitations

export const getCalendarInvitations = createPaginatedGet<CalendarInvitationsData>("/api/Data/CalendarEventsInvitations");

export function addCalendarCompanyInvitations(
  input: CalendarCompanyInvitationInput,
): Promise<void> {
  return http
    .post(
      `/api/Data/CalendarEventsInvitations/${input.eventUid}/InviteCompany/${input.companyUid}`,
      _.omit(input, ["eventUid", "companyUid"]),
    )
    .then(({ data }) => data);
}

export function addCalendarUserInvitations(
  input: CalendarUserInvitationInput,
): Promise<void> {
  return http
    .post(
      `/api/Data/CalendarEventsInvitations/${input.eventUid}/InviteUser/${input.userUid}`,
      _.omit(input, ["eventUid", "userUid"]),
    )
    .then(({ data }) => data);
}

export function addCalendarDepartmentInvitations(
  input: CalendarDepartmentInvitationInput,
): Promise<void> {
  return http
    .post(
      `/api/Data/CalendarEventsInvitations/${input.eventUid}/InviteDepartment/${input.departmentUid}`,
      _.omit(input, ["eventUid", "departmentUid"]),
    )
    .then(({ data }) => data);
}

export const deleteCalendarInvitation = createDelete("/api/Data/CalendarEventsInvitations");

// Invitee responds to their own invitation for an event.
export function acceptCalendarInvitation(eventUid: string): Promise<void> {
  return http
    .post(`/api/Data/CalendarEventsInvitations/${eventUid}/Accept`, {})
    .then(({ data }) => data);
}

export function declineCalendarInvitation(eventUid: string): Promise<void> {
  return http
    .post(`/api/Data/CalendarEventsInvitations/${eventUid}/Decline`, {})
    .then(({ data }) => data);
}

// Calendar Types

export const getCalendarEventTypes = createPaginatedGet<CalendarEventTypesData>("/api/Data/CalendarEventsTypes");

//Badges
export const getBadges = createPaginatedGet<BadgesData>("api/Data/Badges");
export const getBadgesExport = createExportFn("/api/Data/Badges/Export", "badges-export.xlsx");

// Assigned Badges

// Badge assigns — mirror the reward assigns (shared factory; the body carries the dates).
const assignBadgeToCompany = createAssignFn("/api/Data/BadgesAssignment", "Company");
const assignBadgeToDepartment = createAssignFn("/api/Data/BadgesAssignment", "Department");
const assignBadgeToUser = createAssignFn("/api/Data/BadgesAssignment", "User");

export function addCompanyBadge(input: CompanyBadgeInput) {
  return assignBadgeToCompany(input.badgeUid!, input.companyUid!, {
    body: _.omit(input, ["badgeUid", "companyUid"]),
  });
}

export function addDepartmentBadge(input: DepartmentBadgeInput) {
  return assignBadgeToDepartment(input.badgeUid!, input.departmentUid!, {
    body: _.omit(input, ["badgeUid", "departmentUid"]),
  });
}

export function addUserBadge(input: UserBadgeInput) {
  return assignBadgeToUser(input.badgeUid!, input.userUid!, {
    body: _.omit(input, ["badgeUid", "userUid"]),
  });
}

export const getCompanyBadges = createPaginatedGet<CompanyBadgesData>("api/Data/BadgesAssignment/Companies");
export const getCompaniesBadgesExport = createExportFn("/api/Data/BadgesAssignment/Companies/Export", "companies-badges-export.xlsx");
export const deleteCompanyBadge = createDelete("/api/Data/BadgesAssignment/Companies");

export const getDepartmentsBadges = createPaginatedGet<DepartmentsBadgesData>("api/Data/BadgesAssignment/Departments");
export const getDepartmentsBadgesExport = createExportFn("/api/Data/BadgesAssignment/Departments/Export", "departments-badges-export.xlsx");
export const deleteDepartmentBadge = createDelete("/api/Data/BadgesAssignment/Departments");

export const getUsersBadges = createPaginatedGet<UsersBadgesData>("api/Data/BadgesAssignment/Users");
export const getUsersBadgesExport = createExportFn("/api/Data/BadgesAssignment/Users/Export", "users-badges-export.xlsx");
export const deleteUserBadge = createDelete("/api/Data/BadgesAssignment/Users");

// Test Bundles

export const getBundles = createPaginatedGet<BundlesData>("api/Data/Bundles");
export const addBundle = createAdd<BundleInput>("/api/Data/Bundles");
export const updateBundle = createUpdate<BundleInput>("/api/Data/Bundles");
export const deleteBundle = createDelete("/api/Data/Bundles");
export const getBundlesExport = createExportFn("/api/Data/Bundles/Export", "test-bundles-export.xlsx");

export function getBundleLanguages(
  input: PaginationInput,
  bundleUid: string,
): Promise<LanguagesData> {
  const searchQuery = JSON.stringify(input.searchQuery);

  return http
    .get(`/api/Data/Bundles/${bundleUid}/Languages`, {
      params: {
        ..._.omit(input, "searchQuery"),
        searchQuery,
      },
    })
    .then(({ data }) => data);
}

export function addBundleLanguage(bundleUid: string, value: string) {
  return http
    .post(`/api/Data/Bundles/${bundleUid}/AssignLanguage/${value}`)
    .then(({ data }) => data);
}

export function deleteBundleLanguage(bundleUid: string, value: string) {
  return http
    .delete(`/api/Data/Bundles/${bundleUid}/RemoveLanguage/${value}`)
    .then(({ data }) => data);
}

export function getBundleQuestionnaires(
  input: PaginationInput,
  bundleUid: string,
): Promise<BundleQuestionnairesData> {
  const searchQuery = JSON.stringify(input.searchQuery);

  return http
    .get(`/api/Data/Bundles/${bundleUid}/Questionnaires`, {
      params: {
        ..._.omit(input, "searchQuery"),
        searchQuery,
      },
    })
    .then(({ data }) => data);
}

export function addBundleQuestionnaire(
  bundleUid: string,
  value: string,
  input: BundleQuestionnaireInput,
) {
  return http
    .post(`/api/Data/Bundles/${bundleUid}/AssignQuestionnaire/${value}`, input)
    .then(({ data }) => data);
}

export function deleteBundleQuestionnaire(bundleUid: string, value: string) {
  return http
    .delete(`/api/Data/Bundles/${bundleUid}/RemoveQuestionnaire/${value}`)
    .then(({ data }) => data);
}

// Bundles Assignments

export const getBundlesAssignments = createPaginatedGet<BundlesAssignmentsData>("/api/Data/BundlesCompanies");
export const addBundleAssignment = createAdd<BundleAssignmentInput>("/api/Data/BundlesCompanies");
export const updateBundleAssignment = createUpdate<BundleAssignmentUpdateInput>("/api/Data/BundlesCompanies");
export const deleteBundlesAssignment = createDelete("/api/Data/BundlesCompanies");
export const getBundlesAssignmentsExport = createExportFn("/api/Data/BundlesCompanies/Export", "bundles-assignments-export.xlsx");

// Test Groups

export const getTestGroups = createPaginatedGet<TestGroupData>("api/Data/BundlesTestGroups");
export const addTestGroup = createAdd<TestGroupInput>("/api/Data/BundlesTestGroups");
export const updateTestGroup = createUpdate<TestGroupInput>("/api/Data/BundlesTestGroups");
export const deleteTestGroup = createDelete("/api/Data/BundlesTestGroups");

export function getTestGroupUsers(uid: string): Promise<TestGroupUserData> {
  return http
    .get(`/api/Data/BundlesTestGroups/${uid}/Users`)
    .then(({ data }) => data);
}

export function addTestGroupUser(TestGroupUid: string, userUid: string) {
  return http
    .post(`/api/Data/BundlesTestGroups/${TestGroupUid}/AssignUser/${userUid}`)
    .then(({ data }) => data);
}

export function deleteTestGroupUser(TestGroupUid: string, userUid: string) {
  return http
    .delete(`/api/Data/BundlesTestGroups/${TestGroupUid}/RemoveUser/${userUid}`)
    .then(({ data }) => data);
}

export const getTestGroupsExport = createExportFn("api/Data/BundlesTestGroups/Export", "test-group-export.xlsx");

// Questionnaires

export const getQuestionnaires = createPaginatedGet<QuestionnairesData>("/api/Data/Questionnaires");
export const getQuestionnairesExport = createExportFn("/api/Data/Questionnaires/Export", "questionnaires-export.xlsx");
export const addQuestionnaire = createAdd<QuestionnaireInput, Questionnaire>("/api/Data/Questionnaires");
export const updateQuestionnaire = createUpdate<QuestionnaireInput, Questionnaire>("/api/Data/Questionnaires");
export const deleteQuestionnaire = createDelete("/api/Data/Questionnaires");
export const getQuestionnaire = createGetById<Questionnaire>("/api/Data/Questionnaires");

// Start a new Draft version, cloned from this questionnaire's published version. Resolves to the draft.
export function newQuestionnaireVersion(uid: string): Promise<Questionnaire> {
  return http.post(`/api/Data/Questionnaires/${uid}/NewVersion`).then(({ data }) => data);
}

// Publish a Draft: the previous version is retired, and roadmap steps, bundles and reports move onto this one.
export function publishQuestionnaire(uid: string): Promise<Questionnaire> {
  return http.post(`/api/Data/Questionnaires/${uid}/Publish`).then(({ data }) => data);
}

// Sections
export const getQuestionnairesSections = createPaginatedGet<QuestionnaireSectionsData>("/api/Data/QuestionnairesSections");
export const addQuestionnaireSection = createAdd<QuestionnaireSectionInput, QuestionnaireSection>("/api/Data/QuestionnairesSections");
export const updateQuestionnaireSection = createUpdate<QuestionnaireSectionInput, QuestionnaireSection>("/api/Data/QuestionnairesSections");
export const deleteQuestionnaireSection = createDelete("/api/Data/QuestionnairesSections");

// Questions
export const getQuestions = createPaginatedGet<Pagination<Question>>("/api/Data/QuestionnairesQuestions");

export function getQuestionnairesQuestions(
  input: PaginationInput,
  sectionUid: string,
): Promise<QuestionnaireQuestionsData> {
  const searchQuery = JSON.stringify(input.searchQuery);
  return http
    .get(`/api/Data/QuestionnairesSections/${sectionUid}/Questions`, {
      params: {
        ..._.omit(input, "searchQuery"),
        searchQuery,
      },
    })
    .then(({ data }) => data);
}

export const addQuestionnaireQuestion = createAdd<QuestionnaireQuestionInput, QuestionnaireQuestion>("/api/Data/QuestionnairesQuestions");
export const updateQuestionnaireQuestion = createUpdate<QuestionnaireQuestionInput, QuestionnaireQuestion>("/api/Data/QuestionnairesQuestions");
export const deleteQuestionnaireQuestion = createDelete("/api/Data/QuestionnairesQuestions");

// Question Choices
export const addQuestionnaireChoice = createAdd<QuestionnaireQuestionChoiceInput & { questionUid: string }, QuestionnaireQuestionChoice>("/api/Data/QuestionnairesQuestionsChoices");

export function getQuestionnaireQuestionChoices(
  input: PaginationInput,
  questionUid: string,
): Promise<QuestionnaireQuestionChoicesData> {
  const searchQuery = JSON.stringify(input.searchQuery);
  return http
    .get(`/api/Data/QuestionnairesQuestions/${questionUid}/Choices`, {
      params: {
        ..._.omit(input, "searchQuery"),
        searchQuery,
      },
    })
    .then(({ data }) => data);
}

export const addQuestionnaireQuestionChoice = createAdd<QuestionnaireQuestionChoiceInput, QuestionnaireQuestionChoice>("/api/Data/QuestionnairesQuestionsChoices");
export const updateQuestionnaireQuestionChoice = createUpdate<QuestionnaireQuestionChoiceInput, QuestionnaireQuestionChoice>("/api/Data/QuestionnairesQuestionsChoices");
export const deleteQuestionnaireQuestionChoice = createDelete("/api/Data/QuestionnairesQuestionsChoices");

export function getQuestionnaireAllSections(
  questionnaireUid: string,
): Promise<QuestionnaireSectionsData> {
  return http
    .get(`/api/Data/QuestionnairesSections`, {
      params: {
        pageNumber: 0,
        pageSize: MAX_PAGE_SIZE,
        searchQuery: JSON.stringify({
          conditions: [
            {
              field: "questionnaireUid",
              values: [questionnaireUid],
              operation: QueryOperation.Equal,
            },
          ],
        }),
        sortBy: "order",
        sortDescending: false,
      },
    })
    .then(({ data }) => data);
}

export function getSectionAllQuestions(
  sectionUid: string,
): Promise<QuestionnaireQuestionsData> {
  return http
    .get(`/api/Data/QuestionnairesQuestions`, {
      params: {
        pageNumber: 0,
        pageSize: MAX_PAGE_SIZE,
        searchQuery: JSON.stringify({
          conditions: [
            {
              field: "sectionUid",
              values: [sectionUid],
              operation: QueryOperation.Equal,
            },
          ],
        }),
      },
    })
    .then(({ data }) => data);
}

export function getQuestionAllChoices(
  questionUid: string,
): Promise<QuestionnaireQuestionChoicesData> {
  return http
    .get(`/api/Data/QuestionnairesQuestionsChoices`, {
      params: {
        pageNumber: 0,
        pageSize: MAX_PAGE_SIZE,
        searchQuery: JSON.stringify({
          conditions: [
            {
              field: "questionUid",
              values: [questionUid],
              operation: QueryOperation.Equal,
            },
          ],
        }),
      },
    })
    .then(({ data }) => data);
}

// Question Translations
export const getQuestionnaireQuestionTranslations = createPaginatedGet<QuestionnaireQuestionTranslationsData>("/api/Data/QuestionnairesQuestionsTranslations");

export function addQuestionnaireQuestionTranslation(
  input: QuestionnaireQuestionTranslationInput,
): Promise<QuestionnaireQuestionTranslation> {
  return http
    .post(`/api/Data/QuestionnairesQuestionsTranslations`, {
      translatedDescription: input.translatedDescription,
      questionnaireQuestionUid: input.questionnaireQuestionUid,
      languageUid: input.languageUid,
    })
    .then(({ data }) => data);
}

export function updateQuestionnaireQuestionTranslation(
  input: QuestionnaireQuestionTranslationInput,
): Promise<QuestionnaireQuestionTranslation> {
  return http
    .patch(`/api/Data/QuestionnairesQuestionsTranslations/${input.uid}`, {
      translatedDescription: input.translatedDescription,
      rowVersion: input.rowVersion,
    })
    .then(({ data }) => data);
}

export const deleteQuestionnaireQuestionTranslation = createDelete("/api/Data/QuestionnairesQuestionsTranslations");

// Choice Translations
export const getQuestionnaireQuestionChoiceTranslations = createPaginatedGet<QuestionnaireQuestionChoiceTranslationsData>("/api/Data/QuestionnairesQuestionsChoicesTranslations");

export function addQuestionnaireQuestionChoiceTranslation(
  input: QuestionnaireQuestionChoiceTranslationInput,
): Promise<QuestionnaireQuestionChoiceTranslation> {
  return http
    .post(`/api/Data/QuestionnairesQuestionsChoicesTranslations`, {
      translatedDescription: input.translatedDescription,
      questionnaireQuestionChoiceUid: input.questionnaireQuestionChoiceUid,
      languageUid: input.languageUid,
    })
    .then(({ data }) => data);
}

export function updateQuestionnaireQuestionChoiceTranslation(
  input: QuestionnaireQuestionChoiceTranslationInput,
): Promise<QuestionnaireQuestionChoiceTranslation> {
  return http
    .patch(
      `/api/Data/QuestionnairesQuestionsChoicesTranslations/${input.uid}`,
      {
        translatedDescription: input.translatedDescription,
        rowVersion: input.rowVersion,
      },
    )
    .then(({ data }) => data);
}

export const deleteQuestionnaireQuestionChoiceTranslation = createDelete("/api/Data/QuestionnairesQuestionsChoicesTranslations");

// Questionnnaire Answers

export const getAnswers = createPaginatedGet<AnswerData>("/api/Data/QuestionnairesAnswers");
export const deleteAnswer = createDelete("/api/Data/QuestionnairesAnswers");
export const getAnswersExport = createExportFn("/api/Data/QuestionnairesAnswers/Export", "answers-export.xlsx");

// Questionnaire answer KPI results (read-only; computed by the scoring engine)
export const getQuestionnaireAnswerResults =
  createPaginatedGet<QuestionnaireAnswerKPIResultsData>("/api/Data/QuestionnairesAnswersResults");
export const getQuestionnaireAnswerResultsExport = createExportFn(
  "/api/Data/QuestionnairesAnswersResults/Export",
  "answer-results-export.xlsx",
);

// Questionnaire question answers
export function getQuestionnaireQuestionAnswers(questionnaireAnswerUid: string): Promise<QuestionAnswerData> {
  return http
    .get("/api/Data/QuestionnairesQuestionAnswers", {
      params: {
        pageNumber: 0,
        pageSize: MAX_PAGE_SIZE,
        searchQuery: JSON.stringify({
          conditions: [
            {
              field: "questionnaireAnswerUid",
              operation: QueryOperation.Equal,
              values: [questionnaireAnswerUid],
            },
          ],
        }),
        sortDescending: false,
      },
    })
    .then(({ data }) => data);
}

// Country

export const getCountries = createPaginatedGet<CountriesData>("/api/Data/Countries");


// Template Variables

export const getVariables = createPaginatedGet<VariablesData>("api/Data/TemplatesVariables");

export const getVariablesExport = createExportFn("/api/Data/TemplatesVariables/Export", "variables-export.xlsx");

export const addVariable = createAdd<VariablesInput>("/api/Data/TemplatesVariables");

export const updateVariable = createUpdate<VariablesInput>("/api/Data/TemplatesVariables");

export const deleteVariable = createDelete("/api/Data/TemplatesVariables");

// Template Categories

export const getCategories = createPaginatedGet<CategoriesData>("api/Data/TemplatesCategories");

export const getCategoriesExport = createExportFn("/api/Data/TemplatesCategories/Export", "categories-export.xlsx");

export const addCategory = createAdd<CategoriesInput>("/api/Data/TemplatesCategories");

export const updateCategories = createUpdate<CategoriesInput>("/api/Data/TemplatesCategories");

export const deleteCategories = createDelete("/api/Data/TemplatesCategories");

// Languages (PD-01 §20) — Config CRUD. Serves /api/Data/Languages.

export const getLanguages = createPaginatedGet<LanguagesData>("api/Data/Languages");

export const getLanguagesExport = createExportFn("/api/Data/Languages/Export", "languages-export.xlsx");

export const addLanguage = createAdd<LanguageInput>("/api/Data/Languages");

export const updateLanguage = createUpdate<LanguageInput>("/api/Data/Languages");

export const deleteLanguage = createDelete("/api/Data/Languages");

// Program Categories (PD-01 §20) — Config CRUD. Serves /api/Data/CompanyProgramCategories.

export const getProgramCategories = createPaginatedGet<ProgramCategoriesData>("api/Data/CompanyProgramCategories");

export const getProgramCategoriesExport = createExportFn("/api/Data/CompanyProgramCategories/Export", "program-categories-export.xlsx");

export const addProgramCategory = createAdd<ProgramCategoryInput>("/api/Data/CompanyProgramCategories");

export const updateProgramCategory = createUpdate<ProgramCategoryInput>("/api/Data/CompanyProgramCategories");

export const deleteProgramCategory = createDelete("/api/Data/CompanyProgramCategories");

// Login Logs (PD-01 §21) — read-only. Backend serves /api/Data/UserLoginHistory.

export const getLoginLogs = createPaginatedGet<LoginLogsData>("api/Data/UserLoginHistory");

// Points Rules (PD-01 §8) — admin-managed engagement → points accrual rules.

export const getPointsRules = createPaginatedGet<PointsRulesData>("api/Data/LoyaltyAccrualRules");

export const addPointsRule = createAdd<PointsRuleInput>("/api/Data/LoyaltyAccrualRules");

export const updatePointsRule = createUpdate<PointsRuleInput>("/api/Data/LoyaltyAccrualRules");

export const deletePointsRule = createDelete("/api/Data/LoyaltyAccrualRules");

// Incident Follow-Ups (PD-01 §11)

export const getIncidentFollowUps = createPaginatedGet<IncidentFollowUpsData>("api/Data/IncidentFollowUps");
export const addIncidentFollowUp = createAdd<IncidentFollowUpInput>("/api/Data/IncidentFollowUps");
export const updateIncidentFollowUp = createUpdate<IncidentFollowUpInput>("/api/Data/IncidentFollowUps");
export const deleteIncidentFollowUp = createDelete("/api/Data/IncidentFollowUps");

// Policy Acknowledgments monitoring (PD-01 §6)

export const getCompanyPolicyAcknowledgments = createPaginatedGet<CompanyPolicyAcknowledgmentsData>("api/Data/CompanyPolicyAcknowledgments");

export function sendCompanyPolicyReminder(
  policyUid: string,
  input?: { readonly departmentUid?: string; readonly userUids?: string[] },
): Promise<number> {
  return http
    .post<number>(`/api/Data/CompanyPolicies/${policyUid}/SendReminder`, input ?? {})
    .then(({ data }) => data);
}

// Templates

export const getTemplates = createPaginatedGet<TemplatesData>("api/Data/Templates");

export const addTemplate = createAdd<TemplatesInput>("/api/Data/Templates");

export const updateTemplates = createUpdate<TemplatesInput>("/api/Data/Templates");

export const getTemplatesExport = createExportFn("/api/Data/Templates/Export", "templates-export.xlsx");

export const deleteTemplates = createDelete("/api/Data/Templates");

// Templates Versions

export const getTemplatesVersions = createPaginatedGet<TemplateVersionsData>("/api/Data/TemplatesVersions");

export const previewTemplate = createAdd<TemplatePreviewInput, TemplatePreview>(
  "/api/Data/Templates/preview",
);

// Notifications

export const getMyNotifications = createPaginatedGet<MyNotificationsData>("/api/Data/MyNotifications");

export function readMyNotification(input: MyNotificationRead): Promise<void> {
  return http
    .patch(`/api/Data/MyNotifications/${input.uid}/read`)
    .then(({ data }) => data);
}

export function acknowledgeDelivery(input: MyNotificationRead): Promise<void> {
  return http
    .patch(`/api/Data/MyNotifications/${input.uid}/delivered`)
    .then(({ data }) => data);
}

export const getNotifications = createPaginatedGet<NotificationsData>("/api/Data/Notifications");

export const getNotification = createGetById<Notification>("/api/Data/Notifications");

export const addNotification = createAdd<NotificationInput>("/api/Data/Notifications");

export const updateNotification = createUpdate<Omit<NotificationInput, "type">>("/api/Data/Notifications");

export const deleteNotification = createDelete("/api/Data/Notifications");

export const getNotificationsExport = createExportFn("/api/Data/Notifications/Export", "notifications-export.xlsx");

// Notification Recipients

export const getNotificationRecipients = createPaginatedGet<NotificationRecipientsData>("/api/Data/NotificationsRecipients");

export const getNotificationRecipientsExport = createExportFn("/api/Data/NotificationsRecipients/Export", "notification-receipts-export.xlsx");

// Triggers

export const getTemplateEvents = createPaginatedGet<TemplateEventsData>("api/Data/TemplatesEvents");

export const getTemplatesEventsExport = createExportFn("/api/Data/TemplatesEvents/Export", "templates-events-export.xlsx");

export const addTemplateEvent = createAdd<TemplateEventInput>("/api/Data/TemplatesEvents");

export const updateTemplateEvent = createUpdate<TemplateEventInput>("/api/Data/TemplatesEvents");

export const deleteTemplateEvent = createDelete("/api/Data/TemplatesEvents");

// Incidents

export const getIncidents = createPaginatedGet<IncidentsData>("api/Data/Incidents");
export const getIncident = createGetById<Incident>("/api/Data/Incidents");
export const getIncidentsExport = createExportFn("/api/Data/Incidents/Export", "incidents-export.xlsx");
export const addIncident = createAdd<IncidentInput, Incident>("/api/Data/Incidents");
export const updateIncident = createUpdate<Omit<IncidentInput, "companyUid" | "departmentUid" | "isAnonymous">, Incident>("/api/Data/Incidents");
export const deleteIncident = createDelete("/api/Data/Incidents");

// Incident Comments

export function getIncidentComments(
  input: IncidentCommentsInput,
): Promise<IncidentCommentsData> {
  const searchQuery = JSON.stringify(input.searchQuery);

  return http
    .get(`/api/Data/Incidents/${input.incidentUid}/Comments`, {
      params: {
        ..._.omit(input, "searchQuery"),
        searchQuery,
      },
    })
    .then(({ data }) => data);
}

export function addIncidentComments(input: AddIncidentCommentInput) {
  return http
    .post(`/api/Data/Incidents/${input.incidentUid}/Comments`, input)
    .then(({ data }) => data);
}

export const updateIncidentComments = createUpdate<IncidentCommentInput>("/api/Data/Incidents/Comments");
export const deleteIncidentComments = createDelete("/api/Data/Incidents/Comments");

// Reveal the (otherwise masked) reporter behind an anonymous incident — admin-only on the backend.
export const getIncidentReporter = (uid: string): Promise<IncidentReporter> =>
  http
    .get<IncidentReporter>(`/api/Data/Incidents/${uid}/reporter`)
    .then(({ data }) => data);

// Incident Types (admin reference catalog)

export const getIncidentTypes = createPaginatedGet<IncidentTypesData>("api/Data/IncidentTypes");
export const getIncidentType = createGetById<IncidentType>("/api/Data/IncidentTypes");
export const addIncidentType = createAdd<IncidentTypeInput>("/api/Data/IncidentTypes");
export const updateIncidentType = createUpdate<IncidentTypeInput>("/api/Data/IncidentTypes");
export const deleteIncidentType = createDelete("/api/Data/IncidentTypes");
export const getIncidentTypesExport = createExportFn("/api/Data/IncidentTypes/Export", "incident-types-export.xlsx");

export const getAssetTypes = createPaginatedGet<AssetTypesData>("api/Data/AssetTypes");
export const getAssetType = createGetById<AssetType>("/api/Data/AssetTypes");
export const addAssetType = createAdd<AssetTypeInput>("/api/Data/AssetTypes");
export const updateAssetType = createUpdate<AssetTypeInput>("/api/Data/AssetTypes");
export const deleteAssetType = createDelete("/api/Data/AssetTypes");
export const getAssetTypesExport = createExportFn("/api/Data/AssetTypes/Export", "asset-types-export.xlsx");

export const getAssetSubtypes = createPaginatedGet<AssetSubtypesData>("api/Data/AssetSubtypes");
export const getAssetSubtype = createGetById<AssetSubtype>("/api/Data/AssetSubtypes");
export const addAssetSubtype = createAdd<AssetSubtypeInput>("/api/Data/AssetSubtypes");
export const updateAssetSubtype = createUpdate<AssetSubtypeInput>("/api/Data/AssetSubtypes");
export const deleteAssetSubtype = createDelete("/api/Data/AssetSubtypes");
export const getAssetSubtypesExport = createExportFn("/api/Data/AssetSubtypes/Export", "asset-subtypes-export.xlsx");

export const getCompanyAssets = createPaginatedGet<CompanyAssetsData>("api/Data/CompanyAssets");
export const getCompanyAsset = createGetById<CompanyAsset>("/api/Data/CompanyAssets");
export const addCompanyAsset = createAdd<CompanyAssetInput>("/api/Data/CompanyAssets");
export const updateCompanyAsset = createUpdate<CompanyAssetInput>("/api/Data/CompanyAssets");
export const deleteCompanyAsset = createDelete("/api/Data/CompanyAssets");
export const restoreCompanyAsset = createRestore("/api/Data/CompanyAssets");
export const getArchivedCompanyAssets = createArchivedGet<CompanyAssetsData>("/api/Data/CompanyAssets");

// Per-company incident-type notify rosters (which company roles get notified for a given incident type)

export const getCompanyIncidentNotifiers = createPaginatedGet<IncidentTypeNotifiersData>("/api/Data/CompanyIncidentTypeNotifiers");
export const addCompanyIncidentNotifier = createAdd<IncidentTypeNotifierInput>("/api/Data/CompanyIncidentTypeNotifiers");
export const updateCompanyIncidentNotifier = createUpdate<IncidentTypeNotifierInput>("/api/Data/CompanyIncidentTypeNotifiers");
export const deleteCompanyIncidentNotifier = createDelete("/api/Data/CompanyIncidentTypeNotifiers");

// Collaborators
export const getCollaborators = createPaginatedGet<CollaboratorsData>("api/Data/PlatformCollaborators");
export const addCollaborator = createAdd<CollaboratorInput>("/api/Auth/RegisterCollaborator");
export const getCollaborator = createGetById<Collaborator>("/api/Data/PlatformCollaborators");
export const getCollaboratorsExport = createExportFn("/api/Data/PlatformCollaborators/Export", "collaborators-export.xlsx");
export const deleteCollaborator = createDelete("/api/Data/PlatformCollaborators");

// Tenants

export const getTenants = createPaginatedGet<TenantsData>("api/Data/Tenants");

// Consultants
export const getConsultants = createPaginatedGet<ConsultantsData>("api/Data/PlatformConsultants");
export const addConsultant = createAdd<ConsultantInput>("/api/Auth/RegisterConsultant");
export const getConsultant = createGetById<Consultant>("/api/Data/PlatformConsultants");
export const getConsultantsExport = createExportFn("/api/Data/PlatformConsultants/Export", "consultants-export.xlsx");
export const deleteConsultant = createDelete("/api/Data/PlatformConsultants");

// Platform Roles Permissions

export const getPlatformRolesPermissions = createPaginatedGet<PlatformPermissionData>("api/Data/PlatformRolesPermissions");
export const addPlatformRolePermission = createAdd<PlatformPermissionInput>("/api/Data/PlatformRolesPermissions");
export const updatePlatformRolePermission = createUpdate<PlatformPermissionInput>("/api/Data/PlatformRolesPermissions");
export const deletePlatformRolePermission = createDelete("/api/Data/PlatformRolesPermissions");
export const getPlatformPermissionsExport = createExportFn("/api/Data/PlatformRolesPermissions/Export", "platform-permissions-export.xlsx");

// Admin brief 2026-11-04 — role × page matrix (one fetch, one write per cell).
export function getPlatformPermissionsMatrix(): Promise<PermissionMatrix> {
  return http.get<PermissionMatrix>("/api/Data/PlatformRolesPermissions/Matrix").then(({ data }) => data);
}

export function setPlatformPermissionCell(
  roleUid: string,
  permissionUid: string,
  allowedAction: PermissionAction,
): Promise<void> {
  return http
    .put(`/api/Data/PlatformRolesPermissions/Matrix/${roleUid}/${permissionUid}`, { allowedAction })
    .then(() => undefined);
}

//Company Roles Permissions

export const getCompanyRolesPermissions = createPaginatedGet<CompanyPermissionData>("api/Data/CompanyRolesPermissions");
export const addCompanyRolePermission = createAdd<CompanyPermissionInput>("/api/Data/CompanyRolesPermissions");
export const updateCompanyRolePermission = createUpdate<CompanyPermissionInput>("/api/Data/CompanyRolesPermissions");
export const deleteCompanyRolePermission = createDelete("/api/Data/CompanyRolesPermissions");
export const getCompanyPermissionsExport = createExportFn("/api/Data/CompanyRolesPermissions/Export", "company-permissions-export.xlsx");

//Permission Types

export const getPermissions = createPaginatedGet<PermissionData>("api/Data/Permissions");
export const getPermissionsExport = createExportFn("/api/Data/Permissions/Export", "permissions-export.xlsx");

//Platform Roles

export const getPlatformRoles = createPaginatedGet<PlatformRolesData>("api/Data/PlatformRoles");

// Invoices Page

export const getInvoices = createPaginatedGet<InvoicesData>("api/Data/Invoices");
export const getInvoice = createGetById<Invoice>("/api/Data/Invoices");
export const addInvoice = createAdd<InvoiceInput>("/api/Data/Invoices");
export const updateInvoice = createUpdate<InvoiceInput>("/api/Data/Invoices");
export const deleteInvoice = createDelete("/api/Data/Invoices");
export const getInvoicesExport = createExportFn("/api/Data/Invoices/Export", "invoices-export.xlsx");

//Invoice Items

export const getInvoicesItems = createPaginatedGet<InvoiceItemsData>("/api/Data/InvoicesItems");
export const addInvoiceItem = createAdd<InvoiceItemInput>("/api/Data/InvoicesItems");
export const deleteInvoiceItem = createDelete("/api/Data/InvoicesItems");

//Company Collaborators

export const getCompanyCollaborators = createPaginatedGet<CompanyCollaboratorsData>("/api/Data/CompanyCollaborators");
export const addCompanyCollaborators = createAdd<CompanyCollaboratorInput, Company>("/api/Data/CompanyCollaborators");
export const deleteCompanyCollaborators = createDelete("/api/Data/CompanyCollaborators");

// Consultant<->company assignments use a dedicated endpoint (consultant-role-filtered)
// over the same CompanyCollaborator join table.
export const getCompanyConsultants = createPaginatedGet<CompanyCollaboratorsData>("/api/Data/CompanyConsultants");
export const addCompanyConsultants = createAdd<CompanyCollaboratorInput, Company>("/api/Data/CompanyConsultants");
export const deleteCompanyConsultants = createDelete("/api/Data/CompanyConsultants");

//Colaborator Reports

export const getWellbeingReports = createPaginatedGet<WellbeingReportsData>("api/Data/WellbeingReports");

// Single report by uid (no dedicated get-by-id endpoint) — used to refresh the Manage dialog after edits.
export const getWellbeingReport = (uid: string) =>
  getWellbeingReports({
    searchQuery: { conditions: [{ field: "uid", operation: QueryOperation.Equal, values: [uid] }] },
    pageNumber: 0,
    pageSize: 1,
  }).then(({ data }) => data[0]);

export const addWellbeingReport = createAdd<WellbeingReportInput>("/api/Data/WellbeingReports");
export const updateWellbeingReport = createUpdate<WellbeingReportInput>("/api/Data/WellbeingReports");
export const deleteWellbeingReport = createDelete("/api/Data/WellbeingReports");
export const getWellbeingReportExport = createExportFn("/api/Data/WellbeingReports/Export", "wellbeing-reports-export.xlsx");

// Report-target pickers — the report can target a company / sub-company, a department, or an asset.
// These are reachability-scoped server-side (admin all; company user own + sub-companies; affiliate
// assigned companies + sub-companies), so they work for affiliate authors who can't read the
// platform Company/Department/Asset endpoints.
export const getReportTargetCompanies = (): Promise<ReportTargetOption[]> =>
  http.get("/api/Data/WellbeingReports/TargetCompanies").then(({ data }) => data);

export const getReportTargetDepartments = (companyUid: string): Promise<ReportTargetOption[]> =>
  http
    .get("/api/Data/WellbeingReports/TargetDepartments", { params: { companyUid } })
    .then(({ data }) => data);

export const getReportTargetAssets = (companyUid: string): Promise<ReportTargetOption[]> =>
  http
    .get("/api/Data/WellbeingReports/TargetAssets", { params: { companyUid } })
    .then(({ data }) => data);

// Review lifecycle: author/admin submits a draft to its reviewers; admin reopens a submitted/appraised report.
export function submitReport(uid: string): Promise<void> {
  return http
    .post(`/api/Data/WellbeingReports/${uid}/Submit`, {})
    .then(({ data }) => data);
}

export function reopenReport(uid: string): Promise<void> {
  return http
    .post(`/api/Data/WellbeingReports/${uid}/Reopen`, {})
    .then(({ data }) => data);
}

//Colaborator Report Reviewers

export function getReportReviewers(
  input: PaginationInput,
  uid: string,
): Promise<ReviewersData> {
  const searchQuery = JSON.stringify(input.searchQuery);

  return http
    .get(`/api/Data/WellbeingReports/${uid}/Reviewers`, {
      params: {
        ..._.omit(input, "searchQuery"),
        searchQuery,
      },
    })
    .then(({ data }) => data);
}

export function addReportReviewer(reportUid: string, userUid: string) {
  return http
    .post(`/api/Data/WellbeingReports/${reportUid}/Reviewers/${userUid}`)
    .then(({ data }) => data);
}

export function deleteReportReviewers(reportUid: string, userUid: string) {
  return http
    .delete(`/api/Data/WellbeingReports/${reportUid}/Reviewers/${userUid}`)
    .then(({ data }) => data);
}

//Colaborator Report Files

export function getWellbeingReportFiles(
  input: PaginationInput,
  uid: string,
): Promise<ReportFilesData> {
  const searchQuery = JSON.stringify(input.searchQuery);
  return http
    .get(`api/Data/WellbeingReports/${uid}/Files`, {
      params: {
        ..._.omit(input, "searchQuery"),
        searchQuery,
      },
    })
    .then(({ data }) => data);
}

export function addReportFile(reportUid: string, file: File) {
  const formData = new FormData();
  formData.append("reportFile", file);

  return http
    .post(`api/Data/WellbeingReports/${reportUid}/Files`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(({ data }) => data);
}

export function deleteReportFile(fileUid: string) {
  return http
    .delete(`api/Data/WellbeingReports/Files/${fileUid}`)
    .then(({ data }) => data);
}

export function previewReportFile(fileUid: string) {
  return http
    .get(`/api/Data/WellbeingReports/Files/${fileUid}`, {
      responseType: "blob",
    })
    .then(({ data }) => {
      const pdfUrl = URL.createObjectURL(data);

      window.open(pdfUrl, "_blank");
    });
}

// Counselling Requests

export const getCounsellingRequests = createPaginatedGet<CounsellingRequestsData>("/api/Data/CounsellingRequests");

// Single request by uid (no dedicated get-by-id endpoint) — used to deep-link from a calendar event's origin.
export const getCounsellingRequest = (uid: string) =>
  getCounsellingRequests({
    searchQuery: { conditions: [{ field: "uid", operation: QueryOperation.Equal, values: [uid] }] },
    pageNumber: 0,
    pageSize: 1,
  }).then(({ data }) => data[0]);

export const addCounsellingRequest = createAdd<CounsellingRequestInput>("/api/Data/CounsellingRequests");
export const updateCounsellingRequest = createUpdate<CounsellingRequestUpdateInput>("/api/Data/CounsellingRequests");
export const deleteCounsellingRequest = createDelete("/api/Data/CounsellingRequests");
export const getCounsellingRequestsExport = createExportFn("/api/Data/CounsellingRequests/Export", "counselling-requests-export.xlsx");

// Scheduling negotiation lifecycle actions (POSTs against a single request).
export function proposeCounsellingRequest(uid: string, input: CounsellingProposeInput): Promise<void> {
  return http
    .post(`/api/Data/CounsellingRequests/${uid}/Propose`, input)
    .then(({ data }) => data);
}

export function agreeCounsellingRequest(uid: string): Promise<void> {
  return http
    .post(`/api/Data/CounsellingRequests/${uid}/Agree`, {})
    .then(({ data }) => data);
}

export function cancelCounsellingRequest(uid: string): Promise<void> {
  return http
    .post(`/api/Data/CounsellingRequests/${uid}/Cancel`, {})
    .then(({ data }) => data);
}

export function completeCounsellingRequest(uid: string): Promise<void> {
  return http
    .post(`/api/Data/CounsellingRequests/${uid}/Complete`, {})
    .then(({ data }) => data);
}

// Move an already-scheduled session to a new time (stays Scheduled; the calendar event is moved).
export function rescheduleCounsellingRequest(uid: string, input: CounsellingProposeInput): Promise<void> {
  return http
    .post(`/api/Data/CounsellingRequests/${uid}/Reschedule`, input)
    .then(({ data }) => data);
}

// Trainings

export const getTrainings = createPaginatedGet<TrainingsData>("/api/Data/Trainings");
export const getTraining = createGetById<Training>("/api/Data/Trainings");
export const addTraining = createAdd<TrainingInput, Training>("/api/Data/Trainings");
export const deleteTraining = createDelete("/api/Data/Trainings");
export const getTrainingsExport = createExportFn("/api/Data/Trainings/Export", "trainings-export.xlsx");

// Full-replace PUT (not the PATCH factory): the training PUT keeps the backing calendar event in sync
// and notifies the invitees when the schedule moves, so detail edits must travel through it.
export function updateTraining(uid: string, input: TrainingUpdateInput): Promise<void> {
  return http
    .put(`/api/Data/Trainings/${uid}`, input)
    .then(({ data }) => data);
}

// Lifecycle actions (POSTs against a single training).

// Mark a held training as done, optionally recording attendance against the invitee list in the same call.
export function completeTraining(uid: string, input: { attendance?: TrainingAttendanceItem[] }): Promise<void> {
  return http
    .post(`/api/Data/Trainings/${uid}/Complete`, input)
    .then(({ data }) => data);
}

// Cancel a planned training — tears down its calendar event (invites included) and notifies the invitees.
export function cancelTraining(uid: string): Promise<void> {
  return http
    .post(`/api/Data/Trainings/${uid}/Cancel`, {})
    .then(({ data }) => data);
}

// Mark (or correct) attendance — during the session or after completion.
export function setTrainingAttendance(uid: string, input: { items: TrainingAttendanceItem[] }): Promise<void> {
  return http
    .post(`/api/Data/Trainings/${uid}/Attendance`, input)
    .then(({ data }) => data);
}

// Loyalty History

export const getLoyaltyHistory = createPaginatedGet<LoyaltyHistoryData>("/api/Data/LoyaltyHistory");
export const getLoyalty = createGetById<any>("/api/Data/LoyaltyHistory");
export const getLoyaltyHistoryExport = createExportFn("/api/Data/LoyaltyHistory/Export", "loyalty-history-export.xlsx");

// KPIs

export const getKpis = createPaginatedGet<KpisData>("api/Data/KPIDefinitions");
export const addKpi = createAdd<KpiInput>("/api/Data/KPIDefinitions");
export const updateKpi = createUpdate<KpiInput>("/api/Data/KPIDefinitions");
export const deleteKpi = createDelete("/api/Data/KPIDefinitions");
export const getKpisExport = createExportFn("/api/Data/KPIDefinitions/Export", "Kpis-export.xlsx");

// Assessment Reports (a named lens = a curated set of KPIs)

export const getAssessmentReports = createPaginatedGet<AssessmentReportData>("/api/Data/Reports");
export const getAssessmentReport = createGetById<AssessmentReport>("/api/Data/Reports");
export const addAssessmentReport = createAdd<AssessmentReportInput>("/api/Data/Reports");
export const updateAssessmentReport = createUpdate<AssessmentReportInput>("/api/Data/Reports");
export const deleteAssessmentReport = createDelete("/api/Data/Reports");
export const getAssessmentReportsExport = createExportFn(
  "/api/Data/Reports/Export",
  "reports-export.xlsx",
);

// Report↔KPI junction — the standard generic-controller junction (governed by the "Reports" permission)
export const getReportKpiDefinitions =
  createPaginatedGet<ReportKpiDefinitionData>("/api/Data/ReportsKPIDefinitions");
export const addReportKpiDefinition = createAdd<ReportKpiDefinitionInput>("/api/Data/ReportsKPIDefinitions");
export const deleteReportKpiDefinition = createDelete("/api/Data/ReportsKPIDefinitions");

// Meta-report composition (components + bands) + evaluation — governed by the "Reports" permission.
export const getReportComponents =
  createPaginatedGet<ReportComponentData>("/api/Data/ReportComponents");
export const addReportComponent = createAdd<ReportComponentInput>("/api/Data/ReportComponents");
export const updateReportComponent = createUpdate<ReportComponentInput>("/api/Data/ReportComponents");
export const deleteReportComponent = createDelete("/api/Data/ReportComponents");

export const getReportBands = createPaginatedGet<ReportBandData>("/api/Data/ReportBands");
export const addReportBand = createAdd<ReportBandInput>("/api/Data/ReportBands");
export const updateReportBand = createUpdate<ReportBandInput>("/api/Data/ReportBands");
export const deleteReportBand = createDelete("/api/Data/ReportBands");

export function getReportEvaluation(
  reportUid: string,
  companyUid?: string,
  fiscalPeriodUid?: string,
  departmentUid?: string,
): Promise<ReportEvaluation> {
  return http
    .get<ReportEvaluation>("/api/Data/ReportEvaluation", {
      params: {
        reportUid,
        ...(companyUid ? { companyUid } : {}),
        ...(fiscalPeriodUid ? { fiscalPeriodUid } : {}),
        ...(departmentUid ? { departmentUid } : {}),
      },
    })
    .then(({ data }) => data);
}

// Downloads the current evaluation (same scope) as a PDF.
export function exportReportEvaluationPdf(
  reportUid: string,
  companyUid: string,
  fiscalPeriodUid?: string,
  departmentUid?: string,
): Promise<void> {
  return http
    .get("/api/Data/ReportEvaluation/Export", {
      responseType: "blob",
      params: {
        reportUid,
        companyUid,
        ...(fiscalPeriodUid ? { fiscalPeriodUid } : {}),
        ...(departmentUid ? { departmentUid } : {}),
      },
    })
    .then(({ data, headers }) => {
      const cd = (headers?.["content-disposition"] as string) ?? "";
      const match = cd.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
      const filename = match ? decodeURIComponent(match[1]) : "report.pdf";
      const link = document.createElement("a");
      const url = window.URL.createObjectURL(
        new Blob([data], { type: "application/pdf" }),
      );
      try {
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      } finally {
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    });
}

// F-10 Organizational metrics — governed by the "Metrics" permission.
export const getMetricDefinitions =
  createPaginatedGet<MetricDefinitionData>("/api/Data/MetricDefinitions");
export const updateMetricDefinition =
  createUpdate<MetricDefinitionInput>("/api/Data/MetricDefinitions");

export const getMetricBands = createPaginatedGet<MetricBandData>("/api/Data/MetricBands");
export const addMetricBand = createAdd<MetricBandInput>("/api/Data/MetricBands");
export const updateMetricBand = createUpdate<MetricBandInput>("/api/Data/MetricBands");
export const deleteMetricBand = createDelete("/api/Data/MetricBands");

export const getOrganizationalMetrics =
  createPaginatedGet<OrganizationalMetricEntryData>("/api/Data/OrganizationalMetrics");
export const addOrganizationalMetric =
  createAdd<OrganizationalMetricEntryInput>("/api/Data/OrganizationalMetrics");
export const updateOrganizationalMetric =
  createUpdate<OrganizationalMetricEntryInput>("/api/Data/OrganizationalMetrics");
export const deleteOrganizationalMetric =
  createDelete("/api/Data/OrganizationalMetrics");

// KPIs Questions

export const getKpisQuestions = createPaginatedGet<KpisQuestionsData>("/api/Data/KPIDefinitionsQuestions");
export const addKpiQuestion = createAdd<KpiQuestionInput>("/api/Data/KPIDefinitionsQuestions");
export const deleteKpiQuestions = createDelete("/api/Data/KPIDefinitionsQuestions");

// KPIs Matrices

export const getKpiMatrices = createPaginatedGet<KpiMatricesData>("/api/Data/KPIDefinitionsMatrices");
export const updateKpiMatrix = createUpdate<KpiMatrixInput>("/api/Data/KPIDefinitionsMatrices");
export const addKpiMatrix = createAdd<KpiMatrixInput>("/api/Data/KPIDefinitionsMatrices");

//KPIs Ranges

export const getKpiMatrixRanges = createPaginatedGet<RangesData>("/api/Data/KPIDefinitionsMatricesRanges");
export const addKpiMatrixRange = createAdd<RangeInput>("/api/Data/KPIDefinitionsMatricesRanges");
export const updateKpiMatrixRange = createUpdate<RangeInput>("/api/Data/KPIDefinitionsMatricesRanges");
export const deleteKpiMatrixRange = createDelete("/api/Data/KPIDefinitionsMatricesRanges");

// ── Processes (Roadmaps) ──────────────────────────────────────────────────────

// Roadmaps
export const getRoadmaps = createPaginatedGet<RoadmapsData>("/api/Data/Roadmaps");
export const getRoadmap = createGetById<Roadmap>("/api/Data/Roadmaps");
export const addRoadmap = createAdd<RoadmapInput>("/api/Data/Roadmaps");
export const updateRoadmap = createUpdate<RoadmapInput>("/api/Data/Roadmaps");
export const deleteRoadmap = createDelete("/api/Data/Roadmaps");
export const getRoadmapsExport = createExportFn("/api/Data/Roadmaps/Export", "roadmaps-export.xlsx");

// Make this roadmap the single active journey (deactivates all others).
export function activateRoadmap(uid: string): Promise<Roadmap> {
  return http.post(`/api/Data/Roadmaps/${uid}/Activate`).then(({ data }) => data);
}

// Roadmap Stages
export const getRoadmapStages = createPaginatedGet<RoadmapStagesData>("/api/Data/RoadmapsStages");
export const getRoadmapStage = createGetById<RoadmapStage>("/api/Data/RoadmapsStages");
export const addRoadmapStage = createAdd<RoadmapStageInput>("/api/Data/RoadmapsStages");
export const updateRoadmapStage = createUpdate<RoadmapStageInput>("/api/Data/RoadmapsStages");
export const deleteRoadmapStage = createDelete("/api/Data/RoadmapsStages");
export const getRoadmapStagesExport = createExportFn("/api/Data/RoadmapsStages/Export", "roadmap-stages-export.xlsx");
// Atomically swap two sibling stages' order (server-side, one transaction).
export function reorderRoadmapStages(firstUid: string, secondUid: string): Promise<void> {
  return http.patch("/api/Data/RoadmapsStages/Reorder", { firstUid, secondUid }).then(() => undefined);
}

// Roadmap Stage Requirements
export const getRoadmapRequirements = createPaginatedGet<RoadmapRequirementsData>("/api/Data/RoadmapsStageRequirements");
export const getRoadmapRequirement = createGetById<RoadmapRequirement>("/api/Data/RoadmapsStageRequirements");
export const addRoadmapRequirement = createAdd<RoadmapRequirementInput>("/api/Data/RoadmapsStageRequirements");
export const updateRoadmapRequirement = createUpdate<RoadmapRequirementInput>("/api/Data/RoadmapsStageRequirements");
export const deleteRoadmapRequirement = createDelete("/api/Data/RoadmapsStageRequirements");
export const getRoadmapRequirementsExport = createExportFn("/api/Data/RoadmapsStageRequirements/Export", "roadmap-requirements-export.xlsx");
// Atomically swap two sibling requirements' order (server-side, one transaction).
export function reorderRoadmapRequirements(firstUid: string, secondUid: string): Promise<void> {
  return http.patch("/api/Data/RoadmapsStageRequirements/Reorder", { firstUid, secondUid }).then(() => undefined);
}

// Roadmap Company assignments + progress
export const getRoadmapCompanies = createPaginatedGet<RoadmapCompaniesData>("/api/Data/RoadmapsCompanies");
export const getRoadmapCompany = createGetById<RoadmapCompany>("/api/Data/RoadmapsCompanies");
export const addRoadmapCompany = createAdd<RoadmapCompanyInput>("/api/Data/RoadmapsCompanies");
export const updateRoadmapCompany = createUpdate<RoadmapCompanyInput>("/api/Data/RoadmapsCompanies");
export const deleteRoadmapCompany = createDelete("/api/Data/RoadmapsCompanies");
export const getRoadmapCompaniesExport = createExportFn("/api/Data/RoadmapsCompanies/Export", "roadmap-companies-export.xlsx");

// Admin progress control — step a company's roadmap progress forward / back (with stage rollover).
export function advanceRoadmapCompany(uid: string): Promise<RoadmapCompany> {
  return http.post(`/api/Data/RoadmapsCompanies/${uid}/Advance`).then(({ data }) => data);
}
export function retreatRoadmapCompany(uid: string): Promise<RoadmapCompany> {
  return http.post(`/api/Data/RoadmapsCompanies/${uid}/Retreat`).then(({ data }) => data);
}

// NOTE: roadmap files (template stage files + per-company files) were removed from the MVP UI.
// The backend RoadmapsLevelsFiles / RoadmapCompaniesLevelFiles endpoints remain for future re-intro.

// ============================================================================
// WellBeing Corner
// ============================================================================

// Materials (CRUD + export)
export const getWellbeingMaterials = createPaginatedGet<WellbeingMaterialData>("/api/Data/WellbeingMaterials");
export const addWellbeingMaterial = createAdd<WellbeingMaterialInput>("/api/Data/WellbeingMaterials");
export const updateWellbeingMaterial = createUpdate<WellbeingMaterialInput>("/api/Data/WellbeingMaterials");
export const deleteWellbeingMaterial = createDelete("/api/Data/WellbeingMaterials");
export const getWellbeingMaterialsExport = createExportFn("/api/Data/WellbeingMaterials/Export", "wellbeing-materials-export.xlsx");

// Material files (multipart upload + blob preview + delete)
export function uploadMaterialFile(materialUid: string, file: File) {
  const formData = new FormData();
  formData.append("file", file);
  return http
    .post(`/api/Data/WellbeingMaterials/${materialUid}/Files`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then(({ data }) => data);
}

// The material's attached files (metadata only — no bytes). Used to list/preview Document files.
export function getMaterialFiles(
  materialUid: string,
): Promise<WellbeingMaterialFile[]> {
  return http
    .get(`/api/Data/WellbeingMaterials/${materialUid}/Files`)
    .then(({ data }) => data);
}

// Open the file (pdf/image/doc) in a new tab. The API streams raw bytes with its own content type.
export function previewMaterialFile(fileUid: string) {
  return http
    .get(`/api/Data/WellbeingMaterials/Files/${fileUid}`, { responseType: "blob" })
    .then(({ data }) => {
      const url = URL.createObjectURL(data);
      window.open(url, "_blank");
    });
}

export const deleteMaterialFile = createDelete("/api/Data/WellbeingMaterials/Files");

// Material categories (CRUD + export)
export const getWellbeingMaterialCategories = createPaginatedGet<WellbeingMaterialCategoryData>("/api/Data/WellbeingMaterialCategories");
export const addWellbeingMaterialCategory = createAdd<WellbeingMaterialCategoryInput>("/api/Data/WellbeingMaterialCategories");
export const updateWellbeingMaterialCategory = createUpdate<WellbeingMaterialCategoryInput>("/api/Data/WellbeingMaterialCategories");
export const deleteWellbeingMaterialCategory = createDelete("/api/Data/WellbeingMaterialCategories");
export const getWellbeingMaterialCategoriesExport = createExportFn("/api/Data/WellbeingMaterialCategories/Export", "wellbeing-material-categories-export.xlsx");

// KPI tags on a material
export function getMaterialKpis(materialUid: string) {
  return http
    .get<WellbeingMaterialKpiData>(`/api/Data/WellbeingMaterialsKPIs/${materialUid}/Kpis`)
    .then(({ data }) => data);
}

// Add one or more KPI tags (the endpoint accepts an array; duplicates per KPI are skipped server-side).
export function addMaterialKpis(materialUid: string, tags: WellbeingMaterialKpiInput[]) {
  return http
    .post(`/api/Data/WellbeingMaterialsKPIs/${materialUid}/Kpis`, tags)
    .then(({ data }) => data);
}

export const deleteMaterialKpi = createDelete("/api/Data/WellbeingMaterialsKPIs/Kpis");

// Assignment — add (company/department/user), via the shared assignment-POST factory.
// isRequired is a query param (no body).
const assignMaterialCompany = createAssignFn("/api/Data/WellbeingMaterialsAssignment", "Company");
const assignMaterialDepartment = createAssignFn("/api/Data/WellbeingMaterialsAssignment", "Department");
const assignMaterialUser = createAssignFn("/api/Data/WellbeingMaterialsAssignment", "User");

export function assignMaterialToCompany(materialUid: string, companyUid: string, isRequired: boolean) {
  return assignMaterialCompany(materialUid, companyUid, { params: { isRequired } });
}
export function assignMaterialToDepartment(materialUid: string, departmentUid: string, isRequired: boolean) {
  return assignMaterialDepartment(materialUid, departmentUid, { params: { isRequired } });
}
export function assignMaterialToUser(materialUid: string, userUid: string, isRequired: boolean) {
  return assignMaterialUser(materialUid, userUid, { params: { isRequired } });
}

// Assignment — get (per target) + export
export const getMaterialCompanyAssignments = createPaginatedGet<WellbeingMaterialAssignmentData>("/api/Data/WellbeingMaterialsAssignment/Companies");
export const getMaterialDepartmentAssignments = createPaginatedGet<WellbeingMaterialAssignmentData>("/api/Data/WellbeingMaterialsAssignment/Departments");
export const getMaterialUserAssignments = createPaginatedGet<WellbeingMaterialAssignmentData>("/api/Data/WellbeingMaterialsAssignment/Users");
export const getMaterialCompanyAssignmentsExport = createExportFn("/api/Data/WellbeingMaterialsAssignment/Companies/Export", "wellbeing-material-company-assignments-export.xlsx");
export const getMaterialDepartmentAssignmentsExport = createExportFn("/api/Data/WellbeingMaterialsAssignment/Departments/Export", "wellbeing-material-department-assignments-export.xlsx");
export const getMaterialUserAssignmentsExport = createExportFn("/api/Data/WellbeingMaterialsAssignment/Users/Export", "wellbeing-material-user-assignments-export.xlsx");

// Assignment — delete (per target)
export const deleteMaterialCompanyAssignment = createDelete("/api/Data/WellbeingMaterialsAssignment/Companies");
export const deleteMaterialDepartmentAssignment = createDelete("/api/Data/WellbeingMaterialsAssignment/Departments");
export const deleteMaterialUserAssignment = createDelete("/api/Data/WellbeingMaterialsAssignment/Users");

// Engagement (read-only list + export)
export const getMaterialEngagement = createPaginatedGet<WellbeingMaterialEngagementData>("/api/Data/WellbeingMaterialsEngagement");
export const getMaterialEngagementExport = createExportFn("/api/Data/WellbeingMaterialsEngagement/Export", "wellbeing-material-engagement-export.xlsx");

// Engagement coverage — a material's assigned population + each user's lifecycle status (NotStarted computed) + a summary.
const getCoverage = createPaginatedGet<WellbeingMaterialCoverage>(
  "/api/Data/WellbeingMaterialsEngagement/Coverage",
);
export function getMaterialCoverage(materialUid: string, input: PaginationInput) {
  return getCoverage(input, { materialUid });
}

// Targeting preview — server-paged published materials reachable to a user + the reason each surfaced.
// Reuses the standard paginated-GET factory, injecting userUid as an extra query param.
const getRecommended = createPaginatedGet<WellbeingMaterialRecommendationData>(
  "/api/Data/WellbeingMaterials/Recommended",
);
export function getRecommendedMaterials(
  userUid: string,
  input: PaginationInput,
) {
  return getRecommended(input, { userUid });
}

// Dashboard aggregates — server-computed rollups for the admin dashboard, so the cards never ship
// row populations just to count them. All filters are optional (axios drops undefined params).

export function getDashboardUserActivity(
  filters: DashboardFilters = {},
): Promise<DashboardUserActivity> {
  return http
    .get<DashboardUserActivity>("/api/Data/Dashboard/UserActivity", {
      params: filters,
    })
    .then(({ data }) => data);
}

export function getDashboardQuestionnaireStatus(
  filters: DashboardFilters = {},
): Promise<DashboardQuestionnaireStatus> {
  return http
    .get<DashboardQuestionnaireStatus>("/api/Data/Dashboard/QuestionnaireStatus", {
      params: filters,
    })
    .then(({ data }) => data);
}

export function getDashboardRisks(
  filters: DashboardFilters = {},
): Promise<DashboardRisks> {
  return http
    .get<DashboardRisks>("/api/Data/Dashboard/Risks", {
      params: filters,
    })
    .then(({ data }) => data);
}

// Which risk domains recur, worst-first. A domain is the questionnaire section behind a KPI; results
// from KPIs spanning several sections come back as `unattributedResults` rather than being credited
// to one of them.
export function getDashboardRiskDomains(
  filters: DashboardFilters = {},
): Promise<DashboardRiskDomains> {
  return http
    .get<DashboardRiskDomains>("/api/Data/Dashboard/Risks/Domains", {
      params: filters,
    })
    .then(({ data }) => data);
}

// Risk direction over time — results vs their high-risk slice per bucket (day | week | month).
export function getDashboardRiskTrend(
  filters: DashboardFilters & { bucket?: string } = {},
): Promise<DashboardRiskTrend> {
  return http
    .get<DashboardRiskTrend>("/api/Data/Dashboard/Risks/Trend", {
      params: filters,
    })
    .then(({ data }) => data);
}

export function getDashboardIncidents(
  filters: DashboardFilters = {},
): Promise<DashboardIncidents> {
  return http
    .get<DashboardIncidents>("/api/Data/Dashboard/Incidents", {
      params: filters,
    })
    .then(({ data }) => data);
}

// Server-paged companies-at-risk ranking (worst-first by high-risk share) — the dashboard table
// pages through this instead of the rollup shipping every company at once.
export function getDashboardRiskCompanies(params: {
  questionnaireUid?: string;
  companyUid?: string;
  departmentUid?: string;
  from?: string;
  to?: string;
  pageNumber: number;
  pageSize: number;
}): Promise<DashboardRiskCompaniesPage> {
  return http
    .get<DashboardRiskCompaniesPage>("/api/Data/Dashboard/Risks/Companies", {
      params,
    })
    .then(({ data }) => data);
}

// Server-paged per-company open-incident ranking (worst-first) — point-in-time, so no date range.
export function getDashboardIncidentCompanies(params: {
  companyUid?: string;
  departmentUid?: string;
  pageNumber: number;
  pageSize: number;
}): Promise<DashboardIncidentCompaniesPage> {
  return http
    .get<DashboardIncidentCompaniesPage>("/api/Data/Dashboard/Incidents/Companies", {
      params,
    })
    .then(({ data }) => data);
}

export function getDashboardRewardsLoyalty(
  filters: DashboardFilters = {},
): Promise<DashboardRewardsLoyalty> {
  return http
    .get<DashboardRewardsLoyalty>("/api/Data/Dashboard/RewardsLoyalty", {
      params: filters,
    })
    .then(({ data }) => data);
}

export function getDashboardAffiliates(
  filters: DashboardFilters = {},
): Promise<DashboardAffiliates> {
  return http
    .get<DashboardAffiliates>("/api/Data/Dashboard/Affiliates", {
      params: filters,
    })
    .then(({ data }) => data);
}

// Server-paged per-affiliate workload roster (worst-first by open requests, then planned
// trainings) — every affiliate, idle ones included.
export function getDashboardAffiliateWorkload(params: {
  companyUid?: string;
  from?: string;
  to?: string;
  pageNumber: number;
  pageSize: number;
}): Promise<DashboardAffiliateWorkloadPage> {
  return http
    .get<DashboardAffiliateWorkloadPage>("/api/Data/Dashboard/Affiliates/Workload", {
      params,
    })
    .then(({ data }) => data);
}

// ============================================================================
// Targeting Preview
// ============================================================================

// Resolves a staged set of targets into their distinct user reach (overlaps counted once), flagging
// targets outside the caller's scope (`allowed=false`) before the actual assignment would 403.
export function getTargetingPreview(
  input: TargetingPreviewInput,
): Promise<TargetingPreviewResult> {
  return http
    .post<TargetingPreviewResult>("/api/Data/TargetingPreview", input)
    .then(({ data }) => data);
}
